import i18n from "../../../../Utils/i18next/i18next";
import store from "../../../../store";
import { NotificationManager } from "react-notifications";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { cloneDeep, set } from "lodash";
import { updateDashboardByName } from "../../../../Utils/Sockets";
import moment from "moment";

const { t } = i18n;

export const onSubmit = async (values, props) => {
  const { projectReducer } = store.getState();
  const {
    updateTableRegistry,
    loadData,
    update,
    updateSingleRegistry,
    uuid,
    initialValues,
  } = props;

  const data = cloneDeep(values);

  let payload;

  if (!update) {
    const res = await GlobalAuthFetch({
      path: `/task/${uuid}/subtask`,
      method: "POST",
      data,
    });
    payload = res.payload;
  }

  if (update) {
    const res = await GlobalAuthFetch({
      path: `/task/${uuid}/subtask/${values.uuid}`,
      method: "PUT",
      data,
    });
    payload = res.payload;
  }

  if (payload?.status >= 300 || !payload?.status) {
    props.setErrorHeader(0, true);

    return;
  }

  props.setErrorHeader(0, false);

  //Succes nofify
  loadData();
  NotificationManager.success(i18n.t("global:success"));
  if (updateSingleRegistry) {
    updateSingleRegistry();
  }

  props.handleHide();
};

export const onValidate = (values, props) => {
  const errorsStep0 = {};

  if (!values.subtaskContent) {
    errorsStep0.subtaskContent = t("global:task.errors.subtaskContent");
  }
  if (!values.subtaskAssignee || values?.subtaskAssignee?.length === 0) {
    errorsStep0.subtaskAssignee = t("global:task.errors.subtaskAssignee");
  }
  // if (!values.subtaskStartDate) {
  //   errorsStep0.subtaskStartDate = t("global:task.errors.subtaskStartDate");
  // }
  // if (!values.subtaskEndDate) {
  //   errorsStep0.subtaskEndDate = t("global:task.errors.subtaskEndDate");
  // }

  if (values.subtaskStartDate && values.subtaskEndDate) {
    const startDate = moment(values.subtaskStartDate);
    const endDate = moment(values.subtaskEndDate);

    if (startDate.isAfter(endDate)) {
      errorsStep0.subtaskStartDate = t("global:task.errors.invalidDateRange");
      errorsStep0.subtaskEndDate = t("global:task.errors.invalidDateRange");
    }
  }
  if (!values.subtaskDeadline) {
    errorsStep0.subtaskDeadline = t("global:task.errors.subtaskDeadline");
  }

  if (
    !props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length > 0
  ) {
    props.setErrorHeader(0, true);
  }
  if (
    !!props.steps[0]?.error &&
    !props.isSubmit &&
    Object.keys(errorsStep0).length <= 0
  ) {
    props.setErrorHeader(0, false);
  }

  return { ...errorsStep0 };
};
